import { Action } from '../types'
import { Box, Button, TextareaAutosize } from '@mui/material'
import React from 'react'

export function ActionPreview({
  action,
  clearAction,
}: {
  action?: Action
  clearAction?(): void
}) {
  if (!action) return null
  return (
    <Box>
      <Box>
        {`Current Action: ${action.actionType}`}
        {clearAction && <Button onClick={clearAction}>Remove</Button>}
      </Box>
      {'data' in action && (
        <TextareaAutosize
          cols={140}
          disabled={true}
          value={JSON.stringify(action.data, null, 2)}
        />
      )}
    </Box>
  )
}
